import { getTranslatedGrowthFeaturesFromProductsRpc } from 'feature-store-service-types';
import Raven from 'raven-js';
import { getI18nLangLocale } from 'pricing-pages-lib/utils/languageUtils';
import { buildFilteredHighlightedProducts } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import rpcClient from './rpcClient';
const buildGetFeaturesPromiseByProductLine = productLine => {
  const highlightedProducts = buildFilteredHighlightedProducts({
    productLine,
    productLevels: ['FREE', 'STARTER']
  });
  const promise = rpcClient.call(getTranslatedGrowthFeaturesFromProductsRpc, {
    queryParameters: {
      productApiNames: highlightedProducts,
      i18nLangLocale: getI18nLangLocale()
    }
  }).then(response => {
    return response;
  }).catch(error => {
    if (error && error.status !== 0) {
      Raven.captureException(new Error(`Failed to fetch SuiteStarterFeatureTableContainer data for productLine ${productLine}`), {
        extra: {
          message: error.message,
          file: 'buildGetFeaturesPromisesByProductLine'
        }
      });
    }
  });
  return promise;
};
export default buildGetFeaturesPromiseByProductLine;